import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon
  const refresh = useCallback(async () => {
    try {
      const me = await api.me();
      setUser(me);
    } catch (e) {
      setUser(false);
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);

  // Step 1: verify email+password, returns a 2FA ticket (no cookie yet).
  const login = async (email, password) => {
    return api.login(email, password);
  };
  // Step 2: verify the 6-digit code → cookie is set, user becomes authenticated.
  const verify2fa = async (ticket, code) => {
    const me = await api.verify2fa(ticket, code);
    setUser(me);
    return me;
  };
  const resend2fa = (ticket) => api.resend2fa(ticket);
  const logout = async () => {
    try {
      await api.logout();
    } catch (e) {
      /* ignore */
    }
    setUser(false);
  };
  return (
    <AuthCtx.Provider value={{ user, login, verify2fa, resend2fa, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAdminAuth = () => useContext(AuthCtx);
